import { Loader2 } from 'lucide-react';
import clsx from 'clsx';

export default function LoadingSpinner({
  size = 'md',        // 'sm', 'md', 'lg', 'xl'
  color = 'primary',  // 'primary', 'white', 'gray'
  className = '',
  text = '',
  fullScreen = false,
}) {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  const colorClasses = {
    primary: 'text-primary',
    white: 'text-white',
    gray: 'text-gray-400',
  };

  const spinner = (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-4',
        fullScreen && 'fixed inset-0 bg-white/80 backdrop-blur-sm z-50',
        className
      )}
    >
      <Loader2
        className={clsx(
          sizeClasses[size],
          colorClasses[color],
          'animate-spin'
        )}
      />
      {text && (
        <p className="text-gray-600 font-medium animate-pulse">{text}</p>
      )}
    </div>
  );

  return spinner;
}